import { Button, Modal } from 'semantic-ui-react';
import { objectToString } from 'src/components/helpers';

const AdditionalInfoShow = (props) => {
  const { set_addInfoModal, aditionalinformation } = props;

  return (
    <Modal open onClose={() => set_addInfoModal(false)}>
      <Modal.Header>Información adicional de reserva</Modal.Header>
      <Modal.Content>
        {aditionalinformation.length !== 0 && (
          <div dangerouslySetInnerHTML={{ __html: objectToString(aditionalinformation) }} />
        )}
        <Modal.Actions>
          <Button secondary onClick={() => set_addInfoModal(false)}>
            Cerrar
          </Button>
        </Modal.Actions>
      </Modal.Content>
    </Modal>
  );
};

export default AdditionalInfoShow;
